import { REDUX_ASYNC_STATUSES } from '../../consts/consts';
import { selectSidebarView } from '../sidebar/selectors';
import { SidebarView } from '../sidebar/types';

const isLoadingSelector = (statusKey) => (state) => state.worklistClaims?.[statusKey] === REDUX_ASYNC_STATUSES.LOADING;
const isFailedSelector = (statusKey) => (state) => state.worklistClaims?.[statusKey] === REDUX_ASYNC_STATUSES.FAILED;

export const selectWorklistClaims = (state) => state.worklistClaims?.worklistClaims;
export const selectWorklistClaimsLoading = isLoadingSelector('worklistClaimsStatus');

export const selectWorklistClaimMessages = (state) => state.worklistClaims?.worklistClaimMessages;
export const selectWorklistClaimMessagesLoading = isLoadingSelector('worklistClaimMessagesStatus');

export const selectWorklistClaimUnreadSinceDate = (state) => state.worklistClaims?.worklistClaimUnreadSinceDate;
export const selectWorklistClaimUnreadSinceDateLoading = isLoadingSelector('worklistClaimUnreadSinceDateStatus');

export const selectDeleteWorklistClaimUnreadSinceLoading = isLoadingSelector('deleteWorklistClaimUnreadSinceStatus');

export const selectCreateWorklistClaimMessageLoading = isLoadingSelector('createWorklistClaimMessageStatus');

export const selectCreateWorklistClaimMessageAndConnectedActionsLoading = isLoadingSelector(
  'createWorklistClaimMessageAndConnectedActionsStatus'
);

export const selectUpdateWorklistClaimMessageLoading = isLoadingSelector('updateWorklistClaimMessageStatus');

export const selectMessageRecipientOrganizations = (state) => state.worklistClaims?.messageRecipientOrganizations;
export const selectMessageRecipientOrganizationsLoading = isLoadingSelector('messageRecipientOrganizationsStatus');

export const selectIsCreateMessageTouched = (state) => state.worklistClaims?.isCreateMessageTouched;
export const selectWorklistClaimNewMessageAttachments = (state) => state.worklistClaims?.newMessageAttachments;
export const selectWorklistClaimNewMessageAttachmentsUploadLoading = (state) =>
  state.worklistClaims?.isNewMessageAttachmentsUploadLoading;

export const selectWorklistClaimReplyRecipientId = (state) => state.worklistClaims?.worklistClaimReplyRecipientId;

export const selectWorklistClaimRecommendations = (state) => state.worklistClaims?.worklistClaimRecommendations;
export const selectWorklistClaimRecommendationsLoading = isLoadingSelector('worklistClaimRecommendationsStatus');

export const selectWorklistClaimMessageAiRecommendation = (state) =>
  state.worklistClaims?.worklistClaimMessageAiRecommendation;
export const selectWorklistClaimMessageAiRecommendationLoading = isLoadingSelector(
  'worklistClaimMessageAiRecommendationStatus'
);
export const selectWorklistClaimMessageAiRecommendationFailed = isFailedSelector(
  'worklistClaimMessageAiRecommendationStatus'
);
export const selectWorklistClaimMessageAiRecommendationUnavailable = (state) =>
  state.worklistClaims?.worklistClaimMessageAiRecommendationUnavailable;
export const selectWorklistClaimMessageAiRecommendationEdited = (state) =>
  state.worklistClaims?.worklistClaimMessageAiRecommendationEdited;
export const selectWorklistClaimMessageAiRecommendationRestoreNonce = (state) =>
  state.worklistClaims?.worklistClaimMessageAiRecommendationRestoreNonce;

export const selectPostWorklistClaimBiproLoading = isLoadingSelector('postWorklistClaimBiproStatus');
export const selectPostWorklistClaimBiproError = isFailedSelector('postWorklistClaimBiproStatus');

export const selectPostWorklistClaimSettlementBiproLoading = isLoadingSelector(
  'postWorklistClaimSettlementBiproStatus'
);
export const selectPostWorklistClaimSettlementBiproError = isFailedSelector('postWorklistClaimSettlementBiproStatus');
export const selectWorklistClaimSettlementBiproApiParams = (state) =>
  state.worklistClaims?.worklistClaimSettlementBiproApiParams;

export const selectPostWorklistClaimSettlementPropertyExpertLoading = isLoadingSelector(
  'postWorklistClaimSettlementPropertyExpertStatus'
);
export const selectPostWorklistClaimSettlementPropertyExpertError = isFailedSelector(
  'postWorklistClaimSettlementPropertyExpertStatus'
);
export const selectWorklistClaimSettlementPropertyExpertApiParams = (state) =>
  state.worklistClaims?.worklistClaimSettlementPropertyExpertApiParams;

export const selectWorklistClaimSettlementActionApiParams = (state) => {
  switch (selectSidebarView(state)) {
    case SidebarView.SEND_SETTLEMENT_TO_INSURANCE_API:
      return selectWorklistClaimSettlementBiproApiParams(state);
    case SidebarView.SEND_SETTLEMENT_TO_PROPERTY_EXPERT:
      return selectWorklistClaimSettlementPropertyExpertApiParams(state);
    default:
      return null;
  }
};

export const selectPostWorklistClaimSettlementActionLoading = (state) => {
  switch (selectSidebarView(state)) {
    case SidebarView.SEND_SETTLEMENT_TO_INSURANCE_API:
      return selectPostWorklistClaimSettlementBiproLoading(state);
    case SidebarView.SEND_SETTLEMENT_TO_PROPERTY_EXPERT:
      return selectPostWorklistClaimSettlementPropertyExpertLoading(state);
    default:
      return false;
  }
};

export const selectPostWorklistClaimSettlementActionError = (state) => {
  switch (selectSidebarView(state)) {
    case SidebarView.SEND_SETTLEMENT_TO_INSURANCE_API:
      return selectPostWorklistClaimSettlementBiproError(state);
    case SidebarView.SEND_SETTLEMENT_TO_PROPERTY_EXPERT:
      return selectPostWorklistClaimSettlementPropertyExpertError(state);
    default:
      return false;
  }
};

export const selectWorklistClaimReminders = (state) => state.worklistClaims?.worklistClaimReminders;
export const selectWorklistClaimRemindersLoading = isLoadingSelector('worklistClaimRemindersStatus');

export const selectCreateWorklistClaimReminderLoading = isLoadingSelector('createWorklistClaimReminderStatus');
export const selectUpdateWorklistClaimReminderLoading = isLoadingSelector('updateWorklistClaimReminderStatus');
export const selectDeleteWorklistClaimReminderLoading = isLoadingSelector('deleteWorklistClaimReminderStatus');

export const selectWorklistSelectedFileToBeAttached = (state) => state.worklistClaims?.worklistSelectedFileToBeAttached;
